export default __webpack_public_path__ + "static/media/userdir-negative.89cf551c.svg";